const venueSchemaMapper = (restSchema) => ({
  entityBundle: "venue",
  label: restSchema.label,
  id: restSchema.nid,
  url: { path: restSchema.url },
  uri: { path: restSchema.url },
  fieldAddress: {
    langcode: restSchema.address_langcode,
    countryCode: "",
    locality: restSchema.address_locality,
    postalCode: restSchema.address_postal_code,
    addressLine1: restSchema.address_address_line1,
    organization: restSchema.address_organization,
  },
  fieldGeolocation: {
    lat: restSchema.geo_lat,
    lng: restSchema.geo_lng,
  },
  fieldParentLocation: {
    label: restSchema.parent_location_label,
  },
  fieldCapacity: restSchema.capacity ? Number(restSchema.capacity) : null,
  fieldImage: restSchema.image_url
    ? {
        fieldCredits: restSchema.image_credits,
        fieldMediaImage: {
          alt: restSchema.image_alt,
          title: restSchema.image_title,
          entity: {
            filemime: restSchema.file_mime,
            uri: restSchema.file_uri,
          },
          style: {
            url: restSchema.image_url,
            width: restSchema.image_width,
            height: restSchema.image_height,
          },
          bigPicture: {
            urlPath: restSchema.image_url,
            width: restSchema.image_width,
            height: restSchema.image_height,
          },
        },
      }
    : null,
  fieldExternalDescriptionDe: restSchema.external_description_de,
  fieldExternalDescriptionEn: restSchema.external_description_en,
  fieldAccesibility: restSchema.accessibility_name?.map((name, idx) => ({
    name,
    fieldTaxonomyFrontendId: restSchema.accessibility_frontend_id?.[idx],
  })),
});

export default venueSchemaMapper;
